<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 24 24">
      <path
        d="M11 10V12H10V14H8V12H5.83C5.42 13.17 4.31 14 3 14C2.20435 14 1.44129 13.6839 0.87868 13.1213C0.31607 12.5587 0 11.7956 0 11C0 10.2044 0.31607 9.44129 0.87868 8.87868C1.44129 8.31607 2.20435 8 3 8C4.31 8 5.42 8.83 5.83 10H11ZM3 10C2.73478 10 2.48043 10.1054 2.29289 10.2929C2.10536 10.4804 2 10.7348 2 11C2 11.2652 2.10536 11.5196 2.29289 11.7071C2.48043 11.8946 2.73478 12 3 12C3.26522 12 3.51957 11.8946 3.70711 11.7071C3.89464 11.5196 4 11.2652 4 11C4 10.7348 3.89464 10.4804 3.70711 10.2929C3.51957 10.1054 3.26522 10 3 10ZM16 14C18.67 14 24 15.34 24 18V20H8V18C8 15.34 13.33 14 16 14ZM16 12C14.9391 12 13.9217 11.5786 13.1716 10.8284C12.4214 10.0783 12 9.06087 12 8C12 6.93913 12.4214 5.92172 13.1716 5.17157C13.9217 4.42143 14.9391 4 16 4C17.0609 4 18.0783 4.42143 18.8284 5.17157C19.5786 5.92172 20 6.93913 20 8C20 9.06087 19.5786 10.0783 18.8284 10.8284C18.0783 11.5786 17.0609 12 16 12Z" 
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: "ModeratorKey",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/ModeratorKey.vue